module.exports = "<div class=\"wrapper\">\n    <div class=\"sidebar\" data-color=\"red\">\n        <app-sidebar></app-sidebar>\n    </div>\n    <div class=\"main-panel\">\n        <app-navbar></app-navbar>\n        <router-outlet></router-outlet>\n        <app-footer></app-footer>\n    </div>\n</div> "


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/admin-layout/admin-layout.component.html
// module id = ./src/app/layouts/admin-layout/admin-layout.component.html
// module chunks = main